import { assertArray, assertString } from "core/validation";
import { ROLES, ROLES_OPTIONS } from "services/userService";
const ADV_TYPE_STEtTING_KEY = "data.search.advertisement.types";

export function transformUsers(users, currentUser) {
    return filterCurrentUsers(users).map((u) => transformUserForList(u, currentUser));
}

export function transformUserForList(user, currentUser) {
    const preferences = getPreferences(user);
    const isAdmin = isAdminRole(user);
    const currentUserIsAdmin = isAdminRole(currentUser);
    return {
        ...user,
        name: user.username,
        avatarText: preferences.avatarText ? preferences.avatarText : getAvatarText(user),
        avatarColor: preferences.avatarColor ? preferences.avatarColor : DEFAULT_AVATAR_COLOR,
        privileges: {
            canChangePassword: currentUser.id === user.id,
            canEditSign: currentUserIsAdmin || currentUser.id === user.id,
            canEdit: currentUserIsAdmin || currentUser.id === user.id,
            isAdmin,
        },
        isAdmin,
    };
}

export function transformAdvTypeSettingsToArray(user, advTypes) {
    const types = user.settings && user.settings[ADV_TYPE_STEtTING_KEY] ? user.settings[ADV_TYPE_STEtTING_KEY] : null;
    if (assertString(types)) {
        const ids = types.split(",");
        if (assertArray(ids)) {
            const result = [];
            ids.map((id) => {
                const typ = advTypes.find((ty) => Number(ty.id) === Number(id));
                if (typ) {
                    result.push(typ);
                }
            });
            return result;
        }
    }
    return null;
}
export function transformUserForForm(user, advTypes, currentUser) {
    const role = assertArray(user.roles) ? user.roles[0] : null;
    return {
        ...user,
        form: {
            ...transformUserForList(user, currentUser),
            advertisementTypes: transformAdvTypeSettingsToArray(user, advTypes),
            role: role ? ROLES_OPTIONS.find((r) => r.value === role.id) : null,
        },
    };
}

export function filterKey(key, user, searchQ) {
    return assertString(user[key]) && user[key].toLowerCase && user[key].toLowerCase().includes(searchQ.toLowerCase());
}

export function getPreferences(user) {
    if (user.preferences) {
        try {
            return JSON.parse(user.preferences);
        } catch (e) {
            throw new Error(e);
        }
    }
    return {};
}

export const DEFAULT_AVATAR_COLOR = "#a1a1a1";

export function getAvatarText(user) {
    const first = user.firstName ? user.firstName.substring(0, 1).toUpperCase() : "";
    const last = user.lastName ? user.lastName.substring(0, 1).toUpperCase() : "";
    return first + last;
}

export function filterCurrentUsers(users) {
    return users.filter((user) => {
        return user.id !== 0;
    });
}

export function isNormalUser(user) {
    return assertArray(user.roles) ? user.roles.find((r) => r.id === ROLES.USER) : false;
}

export function isAdminRole(user) {
    return assertArray(user.roles) ? !!user.roles.find((r) => r.id === ROLES.ADMIN) : false;
}
